import { useCallback, useEffect } from 'react';

import { getLevel0Data } from '@VDL/api';

import { useVDLStore } from '@VDL/store/VDLstore';

import type { IGetLevel0Params } from '@VDL/api/types/IGetLevel0Params';
import { isAxiosError } from 'axios';

export const useFetchLevelData = ({ year }: { year: number | null }) => {
  const { setLevel0Data } = useVDLStore();

  const fetchData = useCallback(
    async ({ year }: IGetLevel0Params) => {
      try {
        const response = await getLevel0Data({ year });

        setLevel0Data(response.data);
      } catch (error) {
        if (isAxiosError(error)) {
          console.log(error.message);
        }
      }
    },
    [setLevel0Data]
  );

  useEffect(() => {
    if (!year) return;

    fetchData({ year });
  }, [year, fetchData]);

  return { fetchData };
};
